export default __webpack_public_path__ + "static/media/commission-saved-img.510a3054.svg";